<template>
    <b-overlay>
        <b-card>
            <b-button v-if="$checkPermission($permissions.PermissionCreateAPIToken)" variant="primary" @click="addModal">Dodaj
                žeton
            </b-button>

            <div>
                <b-form-input type="search" v-model="search" placeholder="Išči..." size="sm" class="float-right col-sm-2 mb-1"/>
                <b-table striped responsive="sm" bordered hover :items="filtered" :fields="fields" :filter="search"
                         :per-page="perPage" :current-page="currentPage">
                    <template slot="top-row" slot-scope="{ fields }">
                        <b-td v-for="field in fields" :key="field.key">
                            <b-form-input v-if="field.key == 'name'" size="sm" v-model="filters[field.key]"
                                          :placeholder="field.label"/>
                        </b-td>
                    </template>
                    <template #cell(token)="row">
                        <div class="d-flex align-items-center justify-content-center">
                            <span class="mr-1">{{ maskedToken(row.item) }}</span>
                            <b-button size="sm" class="mr-1" variant="outline-secondary" @click="toggleReveal(row.item.id)">
                                <fa :icon="revealed[row.item.id] ? 'eye-slash' : 'eye'"/>
                            </b-button>
                            <b-button size="sm" variant="outline-secondary" @click="copyToken(row.item.token)">
                                <fa icon="copy"/>
                            </b-button>
                        </div>
                    </template>
                    <template #cell(active)="row">
                        <b-badge v-if="row.item.active" variant="success">Aktiven</b-badge>
                        <b-badge v-else variant="danger">Neaktiven</b-badge>
                    </template>
                    <template #cell(expires_at)="row">
                        {{ formatDate(row.item.expires_at) }}
                    </template>
                    <template #cell(last_used_at)="row">
                        {{ formatDate(row.item.last_used_at) }}
                    </template>
                    <template #cell(created_at)="row">
                        {{ formatDate(row.item.created_at) }}
                    </template>
                    <template #cell(actions)="row">
                        <div class="d-flex justify-content-center">
                            <b-button v-if="$checkPermission($permissions.PermissionCreateAPIToken)" class="mr-1"
                                      @click="editModal(row.item)" variant="warning">
                                <fa icon="edit"/>
                            </b-button>
                            <b-button v-if="$checkPermission($permissions.PermissionDeleteAPIToken)" @click="deleteToken(row.item.id)"
                                      variant="danger">
                                <fa icon="trash"/>
                            </b-button>
                        </div>
                    </template>
                </b-table>
                <b-row>
                    <b-col class="float-left">
                        <b-dropdown variant="outline" :text="'Na stran: ' + perPage" size="sm" class="btn-none">
                            <b-dropdown-item v-model="perPage" v-for="(item, key) in pageOptions" :key="key"
                                             @click="setPerPage(item)">
                                {{ item }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-col>
                    <b-col sm="7" md="6" class="float-right">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="sm"/>
                    </b-col>
                </b-row>
            </div>
        </b-card>

        <b-modal title="Dodaj/uredi API žeton" v-model="modalActive" centered hide-footer no-close-on-backdrop @close="close">
            <template #default>
                <validation-observer ref="loginValidation">
                    <b-form class="auth-login-form mt-2" @submit.prevent>
                        <validation-provider name="Name" rules="required" #default="{ errors }">
                            <b-form-group label="Ime" rules="required" label-for="token-name" invalid-feedback="Ime je obvezno"
                                          :state="errors[0] ? false:null">
                                <b-form-input id="token-name" v-model="tokenObject.name" name="token-name"
                                              :state="errors[0] ? false:null"/>
                            </b-form-group>
                        </validation-provider>
                        <b-form-group label="Datum poteka (neobvezno)">
                            <b-form-datepicker value-as-date reset-button v-model="tokenObject.expires_at" size="sm"/>
                        </b-form-group>
                        <b-form-group v-if="typeFunc == 2" label="Aktiven">
                            <b-form-checkbox v-model="tokenObject.active">Aktiven</b-form-checkbox>
                        </b-form-group>
                        <b-row>
                            <b-col class="text-right">
                                <b-button v-if="typeFunc == 1" type="submit" variant="primary" @click="validationForm">Dodaj</b-button>
                                <b-button v-else-if="typeFunc == 2" type="submit" variant="primary" @click="validationForm">Uredi
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </template>
        </b-modal>
    </b-overlay>
</template>

<script>
    import {ValidationProvider, ValidationObserver} from 'vee-validate'
    import {required} from '@validations'

    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },
        data() {
            return {
                modalActive: false,
                tokenObject: {id: '', name: '', active: true, expires_at: null},
                tokens: [],
                tokenId: '',
                revealed: {},
                search: '',
                perPage: 10,
                pageOptions: [10, 20, 50, 100],
                currentPage: 1,
                totalRows: 1,
                fields: [
                    {key: 'name', label: 'Ime', sortable: true, class: 'text-center'},
                    {key: 'token', label: 'Žeton', class: 'text-center'},
                    {key: 'active', label: 'Aktiven', sortable: true, class: 'text-center'},
                    {key: 'expires_at', label: 'Poteče', sortable: true, class: 'text-center'},
                    {key: 'last_used_at', label: 'Nazadnje uporabljen', sortable: true, class: 'text-center'},
                    {key: 'created_at', label: 'Ustvarjen', sortable: true, class: 'text-center'},
                    {key: 'actions', label: '', class: 'text-center'}
                ],
                filters: {name: ''},
                typeFunc: 0, //1-add, 2-edit
                required
            }
        },
        methods: {
            getTokens() {
                const thisIns = this
                this.$http.get('/api/v1/management/api_token/')
                    .then(function(response) {
                        thisIns.tokens = response.data || []
                    }).catch(function(error) {
                        thisIns.$printWarning(`Napaka! Koda: ${error.response.status}`)
                    })
            },
            addModal() {
                this.tokenObject = {id: '', name: '', active: true, expires_at: null}
                this.modalActive = true
                this.typeFunc = 1
            },
            validationForm() {
                this.$refs.loginValidation.validate().then((response) => {
                    if (response && this.typeFunc === 1) this.addToken()
                    else if (response && this.typeFunc === 2) this.editToken()
                })
            },
            addToken() {
                const thisIns = this
                const payload = {
                    name: thisIns.tokenObject.name,
                    expires_at: thisIns.tokenObject.expires_at instanceof Date ? thisIns.tokenObject.expires_at.toISOString() : null
                }
                this.$http.put('/api/v1/management/api_token/', payload)
                    .then(function() {
                        thisIns.$printSuccess('API žeton je uspešno dodan!')
                        thisIns.modalActive = false
                        thisIns.tokenObject = {id: '', name: '', active: true, expires_at: null}
                        thisIns.getTokens()
                    }).catch(function(error) {
                        thisIns.$printWarning(`Napaka! Koda: ${error.response.status}`)
                    })
            },
            editModal(item) {
                this.tokenObject = {
                    id: item.id,
                    name: item.name,
                    active: item.active,
                    expires_at: item.expires_at ? new Date(item.expires_at) : null
                }
                this.tokenId = item.id
                this.modalActive = true
                this.typeFunc = 2
            },
            editToken() {
                const thisIns = this
                const payload = {
                    name: thisIns.tokenObject.name,
                    active: thisIns.tokenObject.active,
                    expires_at: thisIns.tokenObject.expires_at instanceof Date ? thisIns.tokenObject.expires_at.toISOString() : null
                }
                this.$http.patch(`/api/v1/management/api_token/${thisIns.tokenId}`, payload)
                    .then(function() {
                        thisIns.$printSuccess('API žeton je uspešno urejen!')
                        thisIns.modalActive = false
                        thisIns.tokenObject = {id: '', name: '', active: true, expires_at: null}
                        thisIns.getTokens()
                    }).catch(function(error) {
                        thisIns.$printWarning(`Napaka! Koda: ${error.response.status}`)
                    })
            },
            deleteToken(tokenId) {
                const thisIns = this
                this.$bvModal.msgBoxConfirm('Prosimo potrdite, da želite izbrisati API žeton.', {
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'DA',
                    cancelTitle: 'NE',
                    footerClass: 'p-2',
                    centered: true
                }).then(function(value) {
                    if (value) {
                        thisIns.$http.delete(`/api/v1/management/api_token/${tokenId}`)
                            .then(function() {
                                thisIns.$printSuccess('API žeton je uspešno izbrisan!')
                                thisIns.getTokens()
                            }).catch(function(error) {
                                thisIns.$printWarning(`Napaka! Koda: ${error.response.status}`)
                            })
                    }
                })
            },
            setPerPage(item) {
                this.perPage = item
            },
            close() {
                this.tokenObject = {id: '', name: '', active: true, expires_at: null}
            },
            toggleReveal(id) {
                this.$set(this.revealed, id, !this.revealed[id])
            },
            maskedToken(item) {
                if (!item.token) return ''
                return this.revealed[item.id] ? item.token : `${item.token.substring(0, 8)}...`
            },
            copyToken(token) {
                const thisIns = this
                navigator.clipboard.writeText(token).then(function() {
                    thisIns.$printSuccess('Žeton je kopiran v odložišče!')
                }).catch(function() {
                    thisIns.$printWarning('Kopiranje žetona ni uspelo!')
                })
            },
            formatDate(value) {
                if (!value) return '-'
                return new Date(value).toLocaleDateString('sl')
            }
        },
        computed: {
            filtered() {
                const filtered = this.tokens.filter(token => {
                    return Object.keys(this.filters).every(key => String(token[key]).toLowerCase().includes(this.filters[key].toLowerCase()))
                })
                return filtered.length > 0 ? filtered : [{name: '', token: '', active: '', expires_at: '', last_used_at: '', created_at: ''}]
            }
        },
        created() {
            this.getTokens()
        },
        mounted() {
            this.totalRows = this.tokens.length
        }
    }
</script>

<style>

</style>
